// extracted by mini-css-extract-plugin
export default {"divider":"divider__kXtAd","shape_fill":"shape_fill__cQFa2","cls1":"cls1__ZD5sa","cls2":"cls2__dj9Dk"};